import React from 'react';
import StockHighLowTable from './StockHighLowTable';

const StockHighLowLows = ({ data }) => {
    // Get the date from the first record if data exists
    const dataDate = data && data.length > 0 && data[0].date 
        ? new Date(data[0].date).toLocaleDateString('en-US', { 
            weekday: 'long', 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        })
        : '';

    const infoText = `The 52-Week Lows list shows stocks that have reached their lowest price point in the past 52 weeks during the trading session.${dataDate ? ` (${dataDate})` : ''}`;

    return (
        <StockHighLowTable
            type="lows"
            titleTop="52-Week Lows:"
            title=""
            info={infoText}
            data={data}
        />
    );
};

export default StockHighLowLows;